export default "__VITE_ASSET__DH_AJKgp__"